module.exports = __webpack_public_path__ + "static/img/neibu.914756bd.png";